<qpx-dialog-header [title]="dialogTitle()" (dismiss)="onDismiss()" />

<qpx-dialog-content
    [contentClass]="dialogContentClass()"
    [isProcessing]="isProcessing()"
    [processingAppearance]="processingAppearance()"
>
    <ng-content
        select=":not(qpx-dialog-header):not(qpx-dialog-content):not(qpx-dialog-footer)"
    />
</qpx-dialog-content>

@if (!hideDialogActions()) {
    <qpx-dialog-footer
        [confirmButton]="confirmButton()"
        [cancelButton]="cancelButton()"
        [confirmDisabled]="confirmDisabled()"
        [isProcessing]="isProcessing()"
        [processingAppearance]="processingAppearance()"
        (dismiss)="onDismiss()"
        (confirm)="onConfirm()"
    />
}
